import React, { memo, useCallback } from 'react';
import { Handle, Position, NodeProps, useReactFlow } from 'reactflow';
import cx from 'classnames';

import { AutomationAction, AutomationActionInputMapping } from '@business/entities/automation';
import { openActionSettingsModal } from '../ActionSettingsModal';
import { AutomationService } from '@business/services';

export const ActionNode = ({ id, data }: NodeProps<AutomationAction>) => {
  const { setNodes, getNodes, getEdges, setEdges, deleteElements } = useReactFlow();
  const onSave = useCallback(
    (inputs: AutomationActionInputMapping) => {
      setNodes(nodes =>
        nodes.map(node => {
          if (node.id === id) {
            return { ...node, data: { ...node.data, mapping: inputs } };
          }
          return node;
        }),
      );
    },
    [id, setNodes],
  );

  const onDelete = useCallback(() => {
    deleteElements({ nodes: [{ id }], edges: [] });
  }, [deleteElements, id]);

  const onNodeClick = useCallback(() => {
    openActionSettingsModal({ action: data, onSave, prevNodes: AutomationService.getPrevNodes(id, getNodes(), getEdges()), onDelete });
  }, [data, getEdges, getNodes, id, onDelete, onSave]);

  return (
    <div onClick={() => onNodeClick()} className={cx('node action')} title={data.description}>
      <i className={data.icon}></i>
      {data.name}

      <Handle className={'handle'} type="target" position={Position.Top} isConnectable={false} />
      <Handle className={'handle'} type="source" position={Position.Bottom} isConnectable={false} />
    </div>
  );
};
